import React, { useEffect, useState } from "react";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  userLogin,
  fetchCustomerForgotPasswordSuccess,
  clearLoginMessage,
} from "redux/actions/user";
import { useForm } from "react-hook-form";
import "./login-page.scss";
import Breadcrumb from "components/Common/Breadcrumb";
import { getLocalStorageValue } from "config/helper";

const PIN_PASSWORD_LABEL = "PIN/Password *";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clientId = getLocalStorageValue("RSAclient-id");
  const prePageUrl = getLocalStorageValue("pre_page_url") || "";

  let loginError = useSelector(({ user }) => user.loginError);

  const headerSectionData = useSelector(
    ({ common }) => common.commonDetailsData.header_section
  );

  // Changed label from PIN to Password -1630 - 07/02/2023 - Madhu
  // RequireField - Asterisk formatting - 21/02/2023 - Navina
  const {
    is_numeric_password,
    complex_password_max_length,
    complex_password_min_length,
    numeric_password_length,
  } = headerSectionData;

  if (loginError === "Invalid email or password") {
    loginError = "Invalid Phone/Email or PIN/Password";
  }

  const { register, handleSubmit, errors } = useForm();

  useEffect(() => {
    dispatch(fetchCustomerForgotPasswordSuccess(""));
  }, [dispatch]);

  const handleLoginSuccess = () => {
    prePageUrl === "/signup" || "/forgot-password"
      ? navigate("/")
      : navigate(-1);
  };

  const RSA_API_Version = useSelector(({ common }) => common.commonDetailsData?.header_section?.RSA_API_Version ?? "V2");
  const submitUserLogin = (data) => {
    const { email, password } = data;
    const email_id = email
    const is_mobile_number = email.includes('@') ? "0" : "1";
    const body = {
      RSAClientId: clientId,
      email_id,
      password,
      is_mobile_number,
    };
    dispatch(userLogin(body, handleLoginSuccess, RSA_API_Version));
  };

  const breadcrumbList = [{ lable: "Sign In", link: "" }];

  useEffect(() => {
    return () => {
      dispatch(clearLoginMessage());
    };
  }, [dispatch]);

  const [showMessage, setShowMessage] = useState(false);

  const handleClick = () => {
    setShowMessage(true);
  };

  const minLength = 4;
  const maxLength = 256;

  return (
    <>
        <BreadcrumbDetailed breadcrumbList={breadcrumbList} title={`Sign In`} />
        <div className="login-page-wrapper">
          <div className="container">
            <div className="auth-grid-alignment">
          <div className="auth-grid">
            <div className="auth-grid-items">
              <div className="logo-center-wrapper">
            <img
              src={headerSectionData.rsa_client_logo}
              alt={headerSectionData.image_alt_text}
            />
              </div>
              <h1>
            Great to <br />
            <span>see you back</span>
              </h1>
            </div>
            <div className="auth-grid-items">
              <h2>Sign In</h2>
              <p>
            Don't have an account?{" "}
            <span>
              <Link to="/signup">Create here</Link>
            </span>
              </p>
              <form name="login" onSubmit={handleSubmit(submitUserLogin)}>
            <div className="form-control">
              <label>Phone/Email *</label>
              <input
                name="email"
                placeholder="Enter 10 digit phone number or email"
                id="email"
                maxLength={maxLength}
                ref={register({
                  required: true,
                  validate: (value) => {
                    const phonePattern = /^[0-9]{10}$/;
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (phonePattern.test(value) || emailPattern.test(value)) {
                      return true;
                    }
                    return "Please enter a valid 10 digit phone number or email address.";
                  },
                })}
              />
              {errors.email && errors.email.type === "required" && (
                <span>Please enter phone or email.</span>
              )}
              {errors.email && errors.email.message && (
                <span>{errors.email.message}</span>
              )}
            </div>
            {/*  Changed label from PIN to Password -1630 - 07/02/2023 - Madhu */}
            <div className="form-control">
                      <label>{PIN_PASSWORD_LABEL}</label>
                      <input
                        name="password"
                        id="password"
                        placeholder="Enter pin or password"
                        type="password"
                        maxLength={maxLength}
                        minLength={minLength}
                        ref={register({
                          required: true,
                          minLength: 4,
                          maxLength: +maxLength,
                        })}
                      />
                      {errors.password &&
                        errors.password.type === "required" && (
                          <span>Please enter PIN or Password.</span>
                        )}
                      {/* <Link to="/forgot-password">Forgot PIN ?</Link> */}
                      <div className="forgot-btn">
                      <button type="button" className="link-button" onClick={handleClick}>
                        Forgot PIN?
                      </button>
                      
                      </div>
                      {showMessage && (
                        <p className="help-message">Please contact customer service for resetting PIN.</p>
                      )}
                    </div>
                  {loginError ? (
                    <span className="login-error">{loginError}</span>
                  ) : (
                    ""
                  )}
                  <div className="sign-in-button">
                    <button type="submit">Sign In</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
